import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Tab} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {panes, PANES_INDICES} from '../../../common/dictionaries/kpis';
import {yearFormat} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import FiltersSalesKpiSection from './filters';
import SalesVsBudgets from './salesVsBudgets/index';
import SalesByAgencies from './salesByAgencies/index';
import WarningModal from './modal/warning';
import './index.scss';

const currentYear = parseInt(moment().format(yearFormat), 10);

class SalesKpi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'initialYearSelected': currentYear,
      'finalYearSelected': currentYear,
      'showData': true,
      'modalWasOpen': true,
    };
    this.updateShowData = this.updateShowData.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.SalesKpi, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.clearSales();
    const {activeTabIndex, initialYearSelected, finalYearSelected} = this.state;
    const isSalesByAgency = activeTabIndex === PANES_INDICES.SALES_BY_AGENCY;
    if (isSalesByAgency) {
      this.props.fetchLatestSales();
      return;
    }
    this.props.fetchSalesAndBudgets(initialYearSelected, finalYearSelected);
  }

  closeStockDownloadModal() {
    this.setState({'modalWasOpen': false});
  }

  onTabChange(event, data) {
    const activeTab = data.activeIndex;
    const isSalesByAgency = activeTab === PANES_INDICES.SALES_BY_AGENCY;
    const newState = {'activeTabIndex': activeTab, 'showData': true};

    if (isSalesByAgency) {
      this.props.fetchLatestSales();
      this.setState(newState);
      return;
    }
    this.props.fetchSalesAndBudgets(currentYear, currentYear);
    this.setState(newState);
  }

  updateShowData(value) {
    this.setState({'showData': value});
  }

  renderPanesContent() {
    const {activeTabIndex} = this.state;
    const tabs = {
      [PANES_INDICES.SALES_BY_AGENCY]: this.renderSalesByAgencyPaneContent(),
      [PANES_INDICES.SALES_VS_BUDGETS]: this.renderSalesVsBudgetsPaneContent(),
    };
    return tabs[activeTabIndex] || this.renderSalesByAgencyPaneContent();
  }

  renderSalesByAgencyPaneContent() {
    const {showData} = this.state;
    return showData ? <SalesByAgencies showData={showData} /> : null;
  }

  renderSalesVsBudgetsPaneContent() {
    const {showData} = this.state;
    return showData ? <SalesVsBudgets showData={showData} /> : null;
  }

  render() {
    const {activeTabIndex, modalWasOpen} = this.state;

    return (
      <div className='sales-kpi'>
        <WarningModal
          modalWasOpen={modalWasOpen}
          onCloseModal={this.closeStockDownloadModal.bind(this)}
        />
        <Card raised fluid>
          <div className='navigation-section'>
            <Tab
              menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
              panes={panes}
              activeIndex={activeTabIndex}
              onTabChange={this.onTabChange.bind(this)}
            />
          </div>

          <FiltersSalesKpiSection
            activeTabIndex={activeTabIndex}
            updateShowData={this.updateShowData}
          />
        </Card>
        {this.renderPanesContent()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  clearSales,
  fetchLatestSales,
  fetchSalesAndBudgets,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  clearSales,
  fetchLatestSales,
  fetchSalesAndBudgets,
})(SalesKpi);
